import { render } from "./SubAgentTree.vue?vue&type=template&id=28d33251"
import script from "./SubAgentTree.vue?vue&type=script&lang=js"
export * from "./SubAgentTree.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__